import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import RegionModel, { CreateRegionModel, UpdateRegionModel } from "../../../viewModels/Regions/RegionModel";
import SortObject from "../../../types/SortObject";

const initialState: {
  loading: boolean;
  loadingData: boolean;
  regions: Array<RegionModel>;
  total: number;
  pageSize: number;
  page: number;
  sort?: SortObject;
  searchFilterValue: string;
  regionIdToEdit?: number;
  isEditDrawerLoading: boolean;
  isEditDrawerOpen: boolean;
} = {
  loading: true,
  loadingData: true,

  regions: undefined!,
  total: undefined!,
  pageSize: 10,
  page: 1,

  searchFilterValue: "",

  isEditDrawerLoading: false,
  isEditDrawerOpen: false,
};

const regionsSlice = createSlice({
  name: "regions",
  initialState,
  reducers: {
    loadRegions(state) {
      state.loadingData = true;
      state.page = 1;
    },
    loadRegionsSuccess(state, action: PayloadAction<{ regions: Array<RegionModel>; total: number }>) {
      const { regions, total } = action.payload;
      state.loading = false;
      state.loadingData = false;
      state.regions = regions;
      state.total = total;
    },
    loadRegionsError(state) {
      state.loading = false;
      state.loadingData = false;
    },
    changeTable(state, action: PayloadAction<{ page: number; pageSize: number; sort: SortObject }>) {
      state.page = action.payload.page;
      state.pageSize = action.payload.pageSize;
      state.sort = action.payload.sort;
      state.loadingData = true;
    },
    changeSearchFilterValue(state, action: PayloadAction<string>) {
      state.searchFilterValue = action.payload;
    },
    search(state) {
      state.loadingData = true;
      state.page = 1;
    },
    openEditDrawer(state, action: PayloadAction<number | undefined>) {
      state.regionIdToEdit = action.payload!;
      state.isEditDrawerOpen = true;
    },
    closeEditDrawer(state) {
      if (!state.isEditDrawerLoading) {
        state.regionIdToEdit = undefined!;
        state.isEditDrawerOpen = false;
      }
    },

    createRegion(state, _action: PayloadAction<CreateRegionModel>) {
      state.isEditDrawerLoading = true;
    },
    createRegionSuccess(state) {
      state.isEditDrawerLoading = false;
      state.isEditDrawerOpen = false;
    },
    createRegionError(state) {
      state.isEditDrawerLoading = false;
      state.isEditDrawerOpen = false;
    },

    updateRegion(state, _action: PayloadAction<UpdateRegionModel>) {
      state.isEditDrawerLoading = true;
    },
    updateRegionSuccess(state, action: PayloadAction<UpdateRegionModel>) {
      state.isEditDrawerLoading = false;
      state.isEditDrawerOpen = false;
      const index = state.regions.findIndex((x) => x.id === action.payload.id);
      state.regions[index] = action.payload;
    },
    updateRegionError(state) {
      state.isEditDrawerLoading = false;
      state.isEditDrawerOpen = false;
    },

    deleteRegion(state, _action: PayloadAction<number>) {
      state.loadingData = true;
    },
  },
});

export default regionsSlice;
